import React from 'react';
import { Heart, Shield, Target, Users } from 'lucide-react';
import ROLFLogo from '../components/ROLFLogo';
import NewsletterSection from '../components/NewsletterSection';

const AboutPage = () => (
  <>
    <section style={{ paddingTop: '120px', paddingBottom: '4rem', background: 'var(--off-white)' }}>
      <div className="container">
        <div className="section-header" style={{ marginBottom: '2rem' }}>
          <span className="section-tag">About Us</span>
          <h1>Our Story</h1>
          <p>Realm of Love Foundation was born from a simple belief: that every person deserves access to education, health, and opportunity.</p>
        </div>
      </div>
    </section>

    <section className="section">
      <div className="container">
        <div className="scroll-animate-left" style={{ maxWidth: '800px' }}>
          <span className="section-tag">Our Journey</span>
          <h2 style={{ marginBottom: '1.5rem' }}>From Vision to Impact</h2>
          <p style={{ marginBottom: '1rem' }}>
            Founded in 2021, Realm of Love Foundation (ROLF) began as a community-driven initiative in Gauteng,
            South Africa. What started as a small group of passionate individuals has grown into a registered
            Non-Profit Organisation making a tangible difference across multiple communities.
          </p>
          <p style={{ marginBottom: '1rem' }}>
            Our founders recognised the interconnected challenges facing South African communities — from
            educational gaps to health disparities and limited economic opportunities. ROLF was established
            to address these challenges holistically.
          </p>
          <p>
            Today, we operate across 8 communities in Gauteng, with plans to expand to other provinces.
            Our team of dedicated staff and over 85 volunteers work tirelessly to deliver programmes
            that create lasting, sustainable change.
          </p>
        </div>
      </div>
    </section>

    {/* Values */}
    <section style={{ background: 'var(--off-white)', padding: '5rem 0' }}>
      <div className="container">
        <div className="section-header">
          <span className="section-tag">Our Values</span>
          <h2>What Guides Us</h2>
        </div>
        <div className="grid grid-4">
          {[
            { icon: <Heart size={36} />, title: 'Compassion', desc: 'We lead with empathy and genuine care for every individual we serve.', color: 'var(--rose)' },
            { icon: <Shield size={36} />, title: 'Integrity', desc: 'Transparency and accountability in all our operations and partnerships.', color: 'var(--navy)' },
            { icon: <Target size={36} />, title: 'Impact', desc: 'Measurable, sustainable outcomes that transform communities long-term.', color: 'var(--teal)' },
            { icon: <Users size={36} />, title: 'Ubuntu', desc: '"I am because we are" — community-centered approach to development.', color: 'var(--gold)' }
          ].map((val, i) => (
            <div key={i} className="scroll-animate card" style={{ padding: '2rem', textAlign: 'center', transitionDelay: `${i * 100}ms` }}>
              <div style={{
                width: '80px', height: '80px', borderRadius: '16px',
                background: `${val.color}15`, display: 'flex', alignItems: 'center',
                justifyContent: 'center', margin: '0 auto 1rem', color: val.color
              }}>
                {val.icon}
              </div>
              <h4 style={{ marginBottom: '0.5rem' }}>{val.title}</h4>
              <p style={{ fontSize: '0.875rem' }}>{val.desc}</p>
            </div>
          ))}
        </div>
      </div>
    </section>

    <NewsletterSection />
  </>
);

export default AboutPage;